import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-reading-group-book-info',
  templateUrl: './reading-group-book-info.component.html',
  styleUrl: './reading-group-book-info.component.scss',
})
export class ReadingGroupBookInfoComponent {
  @Input() bookInfo?: { title: string; cover: string; author: string };
}
